import config, { Environment } from '../../../config/config'
import { StagingAccount } from '../../../enums/enums'

/**
 * Checks for the test production account or any staging account.
 * A development environment will also pass the check.
 */
export const hasUrlFeatureFlag = (): boolean => {
  const isEnabled = config.environment !== Environment.PRODUCTION || config.getAccountSlug() === 'test'
  return isEnabled
}

/**
 * Enables the Dax MCQ animation for the studio-app (staging) account and the
 * test (production) account only. Local development also passes because localhost
 * resolves to the studio-app slug.
 */
export const hasDaxAnimationFeatureFlag = (): boolean => {
  const isStudioApp = config.getAccountSlug() === StagingAccount.StudioApp
  const isTestProd = config.environment === Environment.PRODUCTION && config.getAccountSlug() === 'test'

  return isStudioApp || isTestProd
}

/**
 * Checks for the train production account or the studio2 staging account.
 * A development environment will also pass the check.
 */
export const hasUrlFeatureFlagTrain = (): boolean => {
  const isTrain = config.environment === Environment.PRODUCTION && config.getAccountSlug() === 'train'
  const isStudio2 = config.environment === Environment.STAGE && config.getAccountSlug() === 'studio2'
  const isDev = config.environment === Environment.DEVELOPMENT

  const isEnabled = isTrain || isStudio2 || isDev
  return isEnabled
}
